import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class BorderoKeys extends MainKeys {
    get place() {
        return Places.bordero
    }

    get filtroDataInicio() {
        const df = this._intent.getParameterAsString(ParamIds.borderoFiltroDataInicial)
        return df ? new Date(df) : undefined
    }

    set filtroDataInicio(value: Date | undefined) {
        this._intent.setParameter(ParamIds.borderoFiltroDataInicial, value?.toISOString())
    }

    get filtroDataFim() {
        const df = this._intent.getParameterAsString(ParamIds.borderoFiltroDataFinal)
        return df ? new Date(df) : undefined
    }

    set filtroDataFim(value: Date | undefined) {
        this._intent.setParameter(ParamIds.borderoFiltroDataFinal, value?.toISOString())
    }

    get filtroStatus() {
        return this._intent.getParameterAsString(ParamIds.borderoFiltroStatus)
    }

    set filtroStatus(value: string | undefined) {
        this._intent.setParameter(ParamIds.borderoFiltroStatus, value)
    }

    get filtroCdBordero() {
        return this._intent.getParameterAsString(ParamIds.borderoFiltroCodBordero)
    }

    set filtroCdBordero(value: string | undefined) {
        this._intent.setParameter(ParamIds.borderoFiltroCodBordero, value)
    }
}

export default BorderoKeys
